'use client'

import { ProductLocations } from 'product/types/ProductLocations'
import { cx } from 'utils/cx'

import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import type { CommonProps } from '../../types/CommonProps'
import { AddToBagButtonLegacy } from '../AddToBagButton/AddToBagButtonLegacy'
import { BackInStockButtonLegacy } from '../BackInStockButton/BackInStockButtonLegacy'
import { ErrorMessageSlotLegacy } from '../ErrorMessageSlotLegacy/ErrorMessageSlotLegacy'
import { FavoriteButtonLegacy } from '../FavoriteButton/FavoriteButtonLegacy'

import styles from './PrimaryActionsLegacy.module.scss'

type PrimaryActionsProps = Pick<CommonProps, 'product' | 'look'>

export const PDP_PRIMARY_ACTIONS = 'pdp-primary-actions'

export function PrimaryActionsLegacy({ product, look }: PrimaryActionsProps) {
	const { selectedColor } = useColors()

	return (
		<div
			id={PDP_PRIMARY_ACTIONS}
			className={cx(
				styles.primaryActions,
				!selectedColor.isSellable && selectedColor.isUniqueSize && styles.noGap
			)}
		>
			<ErrorMessageSlotLegacy />
			<AddToBagButtonLegacy
				product={product}
				look={look}
				location={ProductLocations.Main}
				dataTestId={dataTestIds['pdp.productInfo.addToBag']}
			/>
			<BackInStockButtonLegacy />
			<FavoriteButtonLegacy product={product} />
		</div>
	)
}
